import { render, staticRenderFns } from "./CmsApp.vue?vue&type=template&id=2b4898bc&"
import script from "./CmsApp.vue?vue&type=script&lang=js&"
export * from "./CmsApp.vue?vue&type=script&lang=js&"
import style0 from "./CmsApp.vue?vue&type=style&index=0&id=2b4898bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports